import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import '@vueform/toggle/themes/default.css';
import VueApexCharts from 'vue3-apexcharts';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

library.add(fas);
library.add(far);




const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);
app.component('apex-chart', VueApexCharts);
window.Apex.chart = { fontFamily: "Roboto Mono" };
app.use(FloatingVue);
app.use(createPinia());
app.use(router);
app.mount('#app');
